import { useCallback } from 'react';
import * as api from '@api/validationSpecialistSubjects';

interface UseVisitUploadsParams {
  clinicalTrialId: string | undefined;
}

export const useVisitUploads = ({ clinicalTrialId }: UseVisitUploadsParams) => {
  const handleDownloadFile = useCallback(
    async (fileId: string) => {
      if (!clinicalTrialId) return;

      try {
        const downloadInfo = await api.getValidationSpecialistFileDownload(clinicalTrialId, fileId);

        const link = document.createElement('a');
        link.href = downloadInfo.url;
        link.download = '';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Failed to download file:', error);
      }
    },
    [clinicalTrialId]
  );

  return {
    handleDownloadFile,
  };
};
